import { request } from 'utils/ajax';
import { BygrUser, BygrUserDetails, PaginatedSearchRequest, PaginationResult, UpdateUserResponse } from 'types';
import { toQueryString } from 'utils/url';

export function getUsers(req: PaginatedSearchRequest): Promise<PaginationResult<BygrUser>> {
    return request('api/user', { query: req }).then((x) => x.json());
}

export function getUsersExportUrl(req: PaginatedSearchRequest) {
    return `api/user/excel?${toQueryString(req)}`;
}

export function updateUser(user: BygrUser): Promise<UpdateUserResponse> {
    return request(`api/user/${user.id}`, { json: true, body: user, method: 'PUT' }).then((x) => x.json());
}

export function getUserDetails(userId: number): Promise<BygrUserDetails> {
    return request(`api/user/${userId}`).then((x) => x.json());
}